import React from 'react';
import './WelcomeSlide.css';
import alexandraPhoto from './assets/alexandra.jpg'; // Импортируем фото

function WelcomeSlide() {
  return (
    <div className="welcome-slide">
      <img src={alexandraPhoto} alt="Александра" className="welcome-image" />
      <h1>Александра, сегодня твой день рождения!</h1>
      <p>В этот особенный день мы хотим сказать тебе самые приятные и теплые слова. Пусть этот день будет наполнен радостью, улыбками и незабываемыми моментами! 🎉🎂🎁</p>
    </div>
  );
}

export default WelcomeSlide;